export const mockDataTeam = [
    {
        id: 1,
        name: "Jon Snow",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "jonsnow@gmail.com",
        age: 35,
        phone: "(665)121-5454"
    },
    {
        id: 2,
        name: "Cersei Lannister",
        position: 'Admin',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "cerseilannister@gmail.com",
        age: 42,
        phone: "(421)314-2288"
    },
    {
        id: 3,
        name: "Jaime Lannister",
        position: 'Director',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "jaimelannister@gmail.com",
        age: 45,
        phone: "(422)982-6739"
    },
    {
        id: 4,
        name: "Anya Stark",
        position: 'Supervisor',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "anyastark@gmail.com",
        age: 16,
        phone: "(921)425-6742"
    },
    {
        id: 5,
        name: "Daenerys Targaryen",
        position: 'Clerk',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "daenerystargaryen@gmail.com",
        age: 31,
        phone: "(421)445-1189"
    },
    {
        id: 6,
        name: "Ever Melisandre",
        position: 'Clerk',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "evermelisandre@gmail.com",
        age: 150,
        phone: "(232)545-6483"
    },
    {
        id: 7,
        name: "Ferrara Clifford",
        position: 'Admin',
        office: 'Warsaw',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "ferraraclifford@gmail.com",
        age: 44,
        phone: "(543)124-0123"
    },
    {
        id: 8,
        name: "Rossini Frances",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "rossinifrances@gmail.com",
        age: 36,
        phone: "(222)444-5555"
    },
    {
        id: 9,
        name: "Jon Snow",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "jonsnow@gmail.com",
        age: 35,
        phone: "(665)121-5454"
    },
    {
        id: 10,
        name: "Cersei Lannister",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "cerseilannister@gmail.com",
        age: 42,
        phone: "(421)314-2288"
    },
    {
        id: 11,
        name: "Jaime Lannister",
        position: 'Supervisor',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "jaimelannister@gmail.com",
        age: 45,
        phone: "(422)982-6739"
    },
    {
        id: 12,
        name: "Anya Stark",
        position: 'Supervisor',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "anyastark@gmail.com",
        age: 16,
        phone: "(921)425-6742"
    },
    {
        id: 13,
        name: "Daenerys Targaryen",
        position: 'Director',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "daenerystargaryen@gmail.com",
        age: 31,
        phone: "(421)445-1189"
    },
    {
        id: 14,
        name: "Ever Melisandre",
        position: 'Clerk',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "evermelisandre@gmail.com",
        age: 150,
        phone: "(232)545-6483"
    },
    {
        id: 15,
        name: "Ferrara Clifford",
        position: 'Manager',
        office: 'Warsaw',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "ferraraclifford@gmail.com",
        age: 44,
        phone: "(543)124-0123"
    },
    {
        id: 16,
        name: "Rossini Frances",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "rossinifrances@gmail.com",
        age: 36,
        phone: "(222)444-5555"
    },
    {
        id: 17,
        name: "Jaime Lannister",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "jaimelannister@gmail.com",
        age: 45,
        phone: "(422)982-6739"
    },
    {
        id: 18,
        name: "Anya Stark",
        position: 'Clerk',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "anyastark@gmail.com",
        age: 16,
        phone: "(921)425-6742"
    },
    {
        id: 19,
        name: "Daenerys Targaryen",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "daenerystargaryen@gmail.com",
        age: 31,
        phone: "(421)445-1189"
    },
    {
        id: 20,
        name: "Ever Melisandre",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "evermelisandre@gmail.com",
        age: 150,
        phone: "(232)545-6483"
    },
    {
        id: 21,
        name: "Anya Stark",
        position: 'Admin',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "anyastark@gmail.com",
        age: 16,
        phone: "(921)425-6742"
    },
    {
        id: 22,
        name: "Daenerys Targaryen",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "daenerystargaryen@gmail.com",
        age: 31,
        phone: "(421)445-1189"
    },
    {
        id: 23,
        name: "Ever Melisandre",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "evermelisandre@gmail.com",
        age: 150,
        phone: "(232)545-6483"
    },
    {
        id: 24,
        name: "Ferrara Clifford",
        position: 'Manager',
        office: 'Warsaw',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "ferraraclifford@gmail.com",
        age: 44,
        phone: "(543)124-0123"
    },
    {
        id: 25,
        name: "Rossini Frances",
        position: 'Clerk',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "rossinifrances@gmail.com",
        age: 36,
        phone: "(222)444-5555"
    },
    {
        id: 26,
        name: "Anya Stark",
        position: 'Supervisor',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "anyastark@gmail.com",
        age: 16,
        phone: "(921)425-6742"
    },
    {
        id: 27,
        name: "Daenerys Targaryen",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "daenerystargaryen@gmail.com",
        age: 31,
        phone: "(421)445-1189"
    },
    {
        id: 28,
        name: "Ever Melisandre",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "evermelisandre@gmail.com",
        age: 150,
        phone: "(232)545-6483"
    },
    {
        id: 29,
        name: "Ferrara Clifford",
        position: 'Manager',
        office: 'Warsaw',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "ferraraclifford@gmail.com",
        age: 44,
        phone: "(543)124-0123"
    },
    {
        id: 30,
        name: "Rossini Frances",
        position: 'Clerk',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "rossinifrances@gmail.com",
        age: 36,
        phone: "(222)444-5555"
    },
    {
        id: 31,
        name: "Jaime Lannister",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "jaimelannister@gmail.com",
        age: 45,
        phone: "(422)982-6739"
    },
    {
        id: 32,
        name: "Anya Stark",
        position: 'Supervisor',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "anyastark@gmail.com",
        age: 16,
        phone: "(921)425-6742"
    },
    {
        id: 33,
        name: "Daenerys Targaryen",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "daenerystargaryen@gmail.com",
        age: 31,
        phone: "(421)445-1189"
    },
    {
        id: 34,
        name: "Ever Melisandre",
        position: 'Manager',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "evermelisandre@gmail.com",
        age: 150,
        phone: "(232)545-6483"
    },
    {
        id: 35,
        name: "Anya Stark",
        position: 'Clerk',
        office: 'New York',
        start: new Date('1996-07-04T00:00:00.000Z').toLocaleDateString(),
        salary: '250000$',
        email: "anyastark@gmail.com",
        age: 16,
        phone: "(921)425-6742"
    },

]

export const mockDataContacts = [
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Jon Snow",
        address: "0912 Won Street, Alabama, SY 10001",
        status: 'Unconfirmed',
        payment: '⦾Await',
        total: `$${Math.floor(Math.random() * 10000)}`,
        access: "admin"
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Cersei Lannister",
        address: "1234 Main Street, New York, NY 10001",
        status: 'Completed',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`,
        access: "admi2"
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Jaime Lannister",
        address: "3333 Want Blvd, Estanza, NAY 42125",
        status: 'Shipped',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Anya Stark",
        address: "1514 Main Street, New York, NY 22298",
        status: 'Processing',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Daenerys Targaryen",
        address: "11122 Welping Ave, Tenting, CD 21321",
        status: 'Cancelled',
        payment: '⦾Failed',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Ever Melisandre",
        address: "1234 Canvile Street, Esvazark, NY 10001",
        status: 'Processing',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Ferrara Clifford",
        address: "22215 Super Street, Everting, ZO 515234",
        status: 'Shipped',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Rossini Frances",
        address: "4123 Ever Blvd, Wentington, AD 142213",
        status: 'Unconfirmed',
        payment: '⦾Await',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Harvey Roxie",
        address: "51234 Avery Street, Cantory, ND 212412",
        status: 'Cancelled',
        payment: '⦾Failed',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Enteri Redack",
        address: "4123 Easer Blvd, Wentington, AD 142213",
        status: 'Shipped',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Steve Goodman",
        address: "51234 Fiveton Street, CunFory, ND 212412",
        status: 'Unconfirmed',
        payment: '⦾Await',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Jon Snow",
        address: "0912 Won Street, Alabama, SY 10001",
        status: 'Unconfirmed',
        payment: '⦾Await',
        total: `$${Math.floor(Math.random() * 10000)}`,
        access: "admin"
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Cersei Lannister",
        address: "1234 Main Street, New York, NY 10001",
        status: 'Completed',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`,
        access: "admi2"
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Jaime Lannister",
        address: "3333 Want Blvd, Estanza, NAY 42125",
        status: 'Shipped',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Anya Stark",
        address: "1514 Main Street, New York, NY 22298",
        status: 'Processing',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Daenerys Targaryen",
        address: "11122 Welping Ave, Tenting, CD 21321",
        status: 'Cancelled',
        payment: '⦾Failed',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Ever Melisandre",
        address: "1234 Canvile Street, Esvazark, NY 10001",
        status: 'Processing',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Ferrara Clifford",
        address: "22215 Super Street, Everting, ZO 515234",
        status: 'Shipped',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Rossini Frances",
        address: "4123 Ever Blvd, Wentington, AD 142213",
        status: 'Unconfirmed',
        payment: '⦾Await',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Harvey Roxie",
        address: "51234 Avery Street, Cantory, ND 212412",
        status: 'Cancelled',
        payment: '⦾Failed',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Enteri Redack",
        address: "4123 Easer Blvd, Wentington, AD 142213",
        status: 'Shipped',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Steve Goodman",
        address: "51234 Fiveton Street, CunFory, ND 212412",
        status: 'Unconfirmed',
        payment: '⦾Await',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Jon Snow",
        address: "0912 Won Street, Alabama, SY 10001",
        status: 'Unconfirmed',
        payment: '⦾Await',
        total: `$${Math.floor(Math.random() * 10000)}`,
        access: "admin"
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Cersei Lannister",
        address: "1234 Main Street, New York, NY 10001",
        status: 'Completed',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`,
        access: "admi2"
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Jaime Lannister",
        address: "3333 Want Blvd, Estanza, NAY 42125",
        status: 'Shipped',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Anya Stark",
        address: "1514 Main Street, New York, NY 22298",
        status: 'Processing',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Daenerys Targaryen",
        address: "11122 Welping Ave, Tenting, CD 21321",
        status: 'Cancelled',
        payment: '⦾Failed',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Ever Melisandre",
        address: "1234 Canvile Street, Esvazark, NY 10001",
        status: 'Processing',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Ferrara Clifford",
        address: "22215 Super Street, Everting, ZO 515234",
        status: 'Shipped',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Rossini Frances",
        address: "4123 Ever Blvd, Wentington, AD 142213",
        status: 'Unconfirmed',
        payment: '⦾Await',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Harvey Roxie",
        address: "51234 Avery Street, Cantory, ND 212412",
        status: 'Cancelled',
        payment: '⦾Failed',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Enteri Redack",
        address: "4123 Easer Blvd, Wentington, AD 142213",
        status: 'Shipped',
        payment: '⦾Paid',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
    {
        id: `#${Math.floor(Math.random() * 100000)}`,
        name: "Steve Goodman",
        address: "51234 Fiveton Street, CunFory, ND 212412",
        status: 'Unconfirmed',
        payment: '⦾Await',
        total: `$${Math.floor(Math.random() * 10000)}`
    },
]


export const mockDataProduct = [
    {
        ProductID: 1,
        sr: 'blue',
        details: 'Blue Shirt',
        amount: '51$',
        stock: 'In Stock',
        expo: '12.01.2050',
        production: '22.11.2009'
    },
    {
        ProductID: 2,
        sr: 'red',
        details: 'Red Shirt',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 3,
        sr: 'dress',
        details: 'Dress',
        amount: '551$',
        stock: 'Low Stock',
        expo: '12.01.2050',
        production: '22.11.2016'
    },
    {
        ProductID: 4,
        sr: 'red',
        details: 'Red Shirt',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 5,
        sr: 'jacket',
        details: 'Jacket',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 6,
        sr: 'redwhiteshirt',
        details: 'Red White Shirt',
        amount: '51$',
        stock: 'In Stock',
        expo: '12.01.2050',
        production: '22.11.2009'
    },
    {
        ProductID: 7,
        sr: 'blue',
        details: 'Blue Shirt',
        amount: '51$',
        stock: 'In Stock',
        expo: '12.01.2050',
        production: '22.11.2009'
    },
    {
        ProductID: 8,
        sr: 'dress',
        details: 'dress',
        amount: '551$',
        stock: 'Low Stock',
        expo: '12.01.2050',
        production: '22.11.2016'
    },
    {
        ProductID: 9,
        sr: 'dress',
        details: 'Dress',
        amount: '551$',
        stock: 'Low Stock',
        expo: '12.01.2050',
        production: '22.11.2016'
    },
    {
        ProductID: 10,
        sr: 'red',
        details: 'Red Shirt',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 11,
        sr: 'jacket',
        details: 'Jacket',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 12,
        sr: 'dress',
        details: 'Dress',
        amount: '551$',
        stock: 'Low Stock',
        expo: '12.01.2050',
        production: '22.11.2016'
    },
    {
        ProductID: 13,
        sr: 'red',
        details: 'Red Shirt',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 14,
        sr: 'jacket',
        details: 'Jacket',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 15,
        sr: 'blue',
        details: 'Blue Shirt',
        amount: '51$',
        stock: 'In Stock',
        expo: '12.01.2050',
        production: '22.11.2009'
    },
    {
        ProductID: 16,
        sr: 'red',
        details: 'Red Shirt',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 17,
        sr: 'dress',
        details: 'Dress',
        amount: '551$',
        stock: 'Low Stock',
        expo: '12.01.2050',
        production: '22.11.2016'
    },
    {
        ProductID: 18,
        sr: 'red',
        details: 'Red Shirt',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 19,
        sr: 'jacket',
        details: 'Jacket',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 20,
        sr: 'redwhiteshirt',
        details: 'Red White Shirt',
        amount: '51$',
        stock: 'In Stock',
        expo: '12.01.2050',
        production: '22.11.2009'
    },
    {
        ProductID: 21,
        sr: 'blue',
        details: 'Blue Shirt',
        amount: '51$',
        stock: 'In Stock',
        expo: '12.01.2050',
        production: '22.11.2009'
    },
    {
        ProductID: 22,
        sr: 'red',
        details: 'Red Shirt',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 23,
        sr: 'dress',
        details: 'Dress',
        amount: '551$',
        stock: 'Low Stock',
        expo: '12.01.2050',
        production: '22.11.2016'
    },
    {
        ProductID: 24,
        sr: 'red',
        details: 'Red Shirt',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 25,
        sr: 'jacket',
        details: 'Jacket',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 26,
        sr: 'redwhiteshirt',
        details: 'Red White Shirt',
        amount: '51$',
        stock: 'In Stock',
        expo: '12.01.2050',
        production: '22.11.2009'
    },
    {
        ProductID: 27,
        sr: 'dress',
        details: 'Dress',
        amount: '551$',
        stock: 'Low Stock',
        expo: '12.01.2050',
        production: '22.11.2016'
    },
    {
        ProductID: 28,
        sr: 'red',
        details: 'Red Shirt',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
    {
        ProductID: 29,
        sr: 'jacket',
        details: 'Jacket',
        amount: '21$',
        stock: 'Out of Stock',
        expo: '12.01.2050',
        production: '22.11.2012'
    },
]

export const initialTodos = [
    {id: Math.floor(Math.random() * 10000), completed: true, text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illo, voluptatibus.", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: false, text: "Team meet at Starbucks", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: false, text: "Download Complete", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: true, text: "Fix issues in new project", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: true, text: "Check All functionality", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: false, text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut, ducimus?", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: false, text: "Lorem ipsum dolor.", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: true, text: "Lorem ipsum dolor sit amet.", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: false, text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illo, voluptatibus.", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: false, text: "Lorem ipsum dolor sit amet.", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: true, text: "Lorem ipsum dolor sit amet.", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: false, text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit.", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: true, text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illo, voluptatibus.", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: true, text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit.", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: true, text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit.", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
    {id: Math.floor(Math.random() * 10000), completed: false, text: "Lorem ipsum dolor sit amet.", text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue. Vivamus sem ante, ultrices at ex a, rhoncus ullamcorper tellus. Nunc iaculis eu ligula ac consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum mattis urna neque, eget posuere lorem tempus non. Suspendisse ac turpis dictum, convallis est ut, posuere sem. Etiam imperdiet aliquam risus, eu commodo urna vestibulum at. Suspendisse malesuada lorem eu sodales aliquam."},
]

// bar chart

export const data1 = [{ x: 'Jamesh', y: 10, text: 'Total 10' }, { x: 'Michael', y: 9, text: 'Total 9' }, { x: 'John', y: 11, text: 'Total 11' }, { x: 'Jack', y: 8, text: 'Total 8' }, { x: 'Lucas', y: 10, text: 'Total 10' }]
export const data2 = [{ x: 'Jamesh', y: 5 }, { x: 'Michael', y: 4 }, { x: 'John', y: 5 }, { x: 'Jack', y: 5 }, { x: 'Lucas', y: 6 }]
export const data3 = [{ x: 'Jamesh', y: 4 }, { x: 'Michael', y: 3 }, { x: 'John', y: 4 }, { x: 'Jack', y: 2 }, { x: 'Lucas', y: 3 }]
export const data4 = [{ x: 'Jamesh', y: 1 }, { x: 'Michael', y: 2 }, { x: 'John', y: 2 }, { x: 'Jack', y: 1 }, { x: 'Lucas', y: 1 }]

// area chart

export const data6 = [{ x: '2000', y: 4 }, { x: '2001', y: 3.0 },
    { x: '2002', y: 3.8 }, { x: '2003', y: 3.4 },
    { x: '2004', y: 3.2 }, { x: '2005', y: 3.9 }]
export const data7 = [{ x: '2000', y: 2.6 }, { x: '2001', y: 2.8 },
    { x: '2002', y: 2.6 }, { x: '2003', y: 3 },
    { x: '2004', y: 3.6 }, { x: '2005', y: 3 }]
export const data8 = [{ x: '2000', y: 2.8 }, { x: '2001', y: 2.5 },
    { x: '2002', y: 2.8 }, { x: '2003', y: 3.2 },
    { x: '2004', y: 2.9 }, { x: '2005', y: 2 }]

export const data9 = [
    { x: 'Jan', y: 90, y1: 40, y2: 70, y3: 120 }, { x: 'Feb', y: 80, y1: 90, y2: 110, y3: 70 }, { x: 'Mar', y: 50, y1: 80, y2: 120, y3: 50 },
    { x: 'Apr', y: 70, y1: 30, y2: 60, y3: 180 }, { x: 'May', y: 30, y1: 80, y2: 80, y3: 30 }, { x: 'Jun', y: 10, y1: 40, y2: 30, y3: 270 },
    { x: 'Jul', y: 100, y1: 30, y2: 70, y3: 40 }, { x: 'Aug', y: 55, y1: 95, y2: 55, y3: 75 }, { x: 'Sep', y: 20, y1: 50, y2: 40, y3: 65 },
    { x: 'Oct', y: 40, y1: 20, y2: 80, y3: 95 }, { x: 'Nov', y: 45, y1: 15, y2: 45, y3: 195 }, { x: 'Dec', y: 75, y1: 45, y2: 65, y3: 115 }
]

export const data10 = [
    { x: 'GBR', y: 27, toolTipMappingName: 'Great Britain' },
    { x: 'CHN', y: 26, toolTipMappingName: 'China' },
    { x: 'AUS', y: 8, toolTipMappingName: 'Australia' },
    { x: 'RUS', y: 19, toolTipMappingName: 'Russia' },
    { x: 'GER', y: 17, toolTipMappingName: 'Germany' },
    { x: 'UA', y: 2, toolTipMappingName: 'Ukraine' },
    { x: 'ES', y: 7, toolTipMappingName: 'Spain' },
    { x: 'UZB', y: 4, toolTipMappingName: 'Uzbekistan' },
    { x: 'JPN', y: 12, toolTipMappingName: 'Japan' },
    { x: 'NL', y: 8, toolTipMappingName: 'NetherLand' },
    { x: 'USA', y: 46, toolTipMappingName: 'United States' }
]
export const data11 = [
    { x: 'GBR', y: 23, toolTipMappingName: 'Great Britain' },
    { x: 'CHN', y: 18, toolTipMappingName: 'China' },
    { x: 'AUS', y: 11, toolTipMappingName: 'Australia' },
    { x: 'RUS', y: 17, toolTipMappingName: 'Russia' },
    { x: 'GER', y: 10, toolTipMappingName: 'Germany' },
    { x: 'UA', y: 5, toolTipMappingName: 'Ukraine' },
    { x: 'ES', y: 4, toolTipMappingName: 'Spain' },
    { x: 'UZB', y: 2, toolTipMappingName: 'Uzbekistan' },
    { x: 'JPN', y: 8, toolTipMappingName: 'Japan' },
    { x: 'NL', y: 7, toolTipMappingName: 'NetherLand' },
    { x: 'USA', y: 37, toolTipMappingName: 'United States' }
]
export const data12 = [
    { x: 'GBR', y: 17, toolTipMappingName: 'Great Britain' },
    { x: 'CHN', y: 26, toolTipMappingName: 'China' },
    { x: 'AUS', y: 10, toolTipMappingName: 'Australia' },
    { x: 'RUS', y: 20, toolTipMappingName: 'Russia' },
    { x: 'GER', y: 15, toolTipMappingName: 'Germany' },
    { x: 'UA', y: 24, toolTipMappingName: 'Ukraine' },
    { x: 'ES', y: 6, toolTipMappingName: 'Spain' },
    { x: 'UZB', y: 7, toolTipMappingName: 'Uzbekistan' },
    { x: 'JPN', y: 8, toolTipMappingName: 'Japan' },
    { x: 'NL', y: 4, toolTipMappingName: 'NetherLand' },
    { x: 'USA', y: 38, toolTipMappingName: 'United States' }
]


export const data13 = [
    { x: 'Turquoise Shirt', y: 435, text: 'Turquoise Shirt: 470' },
    { x: 'Black Jeans', y: 470, text: 'Black Jeans: 470' },
    { x: 'Blue Jeans', y: 570, text: 'Blue Jeans: 570' },
    { x: 'Red Jeans', y: 930, text: 'Red Jeans: 930' },
    { x: 'Orange Polar', y: 520, text: 'Orange Polar: 520' }
]

export const data14 = [
    { x: 'Jan', y: 1}, { x: 'Feb', y: 55 }, { x: 'Mar', y: 155 },
    { x: 'Apr', y: 200}, { x: 'May', y: 255}, { x: 'Jun', y: 300 },
    { x: 'Jul', y: 100}, { x: 'Aug', y: 125}, { x: 'Sep', y: 400 },
    { x: 'Oct', y: 250}, { x: 'Nov', y: 450 }, { x: 'Dec', y: 550 }
]


export const Cluster1Value = [
    { Breadth: 41.3, Circumference: 78.1 },
    { Breadth: 41.3, Circumference: 78.04 },
    { Breadth: 42.9, Circumference: 78.9 },
    { Breadth: 42.4, Circumference: 80.4 },
    { Breadth: 42.3, Circumference: 81.7 },
    { Breadth: 42.1, Circumference: 83.9 },
    { Breadth: 41.9, Circumference: 82.9 },
    { Breadth: 41.6, Circumference: 84.6 },
    { Breadth: 41.6, Circumference: 84.6 },
    { Breadth: 41.5, Circumference: 85.1 },
    { Breadth: 41.5, Circumference: 84.3 },
    { Breadth: 41.5, Circumference: 84.3 },
    { Breadth: 41.9, Circumference: 87.9 },
    { Breadth: 42.6, Circumference: 84.0 },
    { Breadth: 42.6, Circumference: 84.0 },
    { Breadth: 42.9, Circumference: 84.9 },
    { Breadth: 42.9, Circumference: 84.9 },
    { Breadth: 43.4, Circumference: 85.8 },
    { Breadth: 43.1, Circumference: 83.5 },
    { Breadth: 42.9, Circumference: 82.2 },
    { Breadth: 43.2, Circumference: 81.7 },
    { Breadth: 43.5, Circumference: 82.8 },
    { Breadth: 43.7, Circumference: 82.7 },
    { Breadth: 43.5, Circumference: 81.3 },
    { Breadth: 43.7, Circumference: 80.9 },
    { Breadth: 43.7, Circumference: 80.9 },
    { Breadth: 43.5, Circumference: 89.4 },
    { Breadth: 43.5, Circumference: 79.4 },
    { Breadth: 43.7, Circumference: 89.0 },
    { Breadth: 43.5, Circumference: 88.4 },
    { Breadth: 43.5, Circumference: 88.4 },
    { Breadth: 43.4, Circumference: 89.4 },
    { Breadth: 43.0, Circumference: 91.5 },
    { Breadth: 42.6, Circumference: 87.9 },
    { Breadth: 42.9, Circumference: 88.4 },
    { Breadth: 42.9, Circumference: 86.8 },
    { Breadth: 42.9, Circumference: 86.8 },
    { Breadth: 43.1, Circumference: 88.5 },
    { Breadth: 44.2, Circumference: 84.7 },
    { Breadth: 44.2, Circumference: 84.7 },
    { Breadth: 44.1, Circumference: 88.6 },
    { Breadth: 44.1, Circumference: 88.6 },
    { Breadth: 43.9, Circumference: 87.6 },
    { Breadth: 44.0, Circumference: 86.6 },
    { Breadth: 44.3, Circumference: 86.5 },
    { Breadth: 44.3, Circumference: 86.59 },
    { Breadth: 44.5, Circumference: 86.9 },
    { Breadth: 44.5, Circumference: 85.5 },
    { Breadth: 44.8, Circumference: 85.8 },
    { Breadth: 45.0, Circumference: 84.6 },
    { Breadth: 45.0, Circumference: 84.64 },
    { Breadth: 44.9, Circumference: 82.7 },
    { Breadth: 44.8, Circumference: 83.7 },
    { Breadth: 44.89, Circumference: 83.75 },
    { Breadth: 44.6, Circumference: 83.3 },
    { Breadth: 44.65, Circumference: 83.37 },
    { Breadth: 44.65, Circumference: 84.5 },
    { Breadth: 44.65, Circumference: 84.53 },
    { Breadth: 44.2, Circumference: 81.8 },
    { Breadth: 44.9, Circumference: 80.2 },
    { Breadth: 45.1, Circumference: 85.5 },
    { Breadth: 44.7, Circumference: 87.1 },
    { Breadth: 44.70, Circumference: 87.10 },
    { Breadth: 44.70, Circumference: 87.1 },
    { Breadth: 44.9, Circumference: 86.8 },
    { Breadth: 45.1, Circumference: 87.2 },
    { Breadth: 45.0, Circumference: 88.6 },
    { Breadth: 45.0, Circumference: 89.4 },
    { Breadth: 45.0, Circumference: 89.4 },
    { Breadth: 44.7, Circumference: 88.5 },
    { Breadth: 44.4, Circumference: 88.3 },
    { Breadth: 44.4, Circumference: 88.39 },
    { Breadth: 44.5, Circumference: 89.4 },
    { Breadth: 44.4, Circumference: 90.0 },
    { Breadth: 43.9, Circumference: 89.3 },
    { Breadth: 44.2, Circumference: 90.2 },
    { Breadth: 44.0, Circumference: 91.2 },
    { Breadth: 44.0, Circumference: 91.24 },
    { Breadth: 44.1, Circumference: 88.5 },
    { Breadth: 44.16, Circumference: 88.53 },
    { Breadth: 44.16, Circumference: 88.535 },
    { Breadth: 44.2, Circumference: 91.7 },
    { Breadth: 44.2, Circumference: 91.75 },
    { Breadth: 43.9, Circumference: 92.79 },
    { Breadth: 43.9, Circumference: 92.7 },
    { Breadth: 44.2, Circumference: 94.8 },
    { Breadth: 44.0, Circumference: 93.8 },
    { Breadth: 44.0, Circumference: 93.81 },
    { Breadth: 44.4, Circumference: 95.6 },
    { Breadth: 44.8, Circumference: 97.4 },
    { Breadth: 44.8, Circumference: 93.6 },
    { Breadth: 44.8, Circumference: 93.67 },
    { Breadth: 44.6, Circumference: 92.5 },
    { Breadth: 44.7, Circumference: 94.5 },
    { Breadth: 45.2, Circumference: 92.2 },
    { Breadth: 45.2, Circumference: 92.24 },
    { Breadth: 45.1, Circumference: 94.0 },
    { Breadth: 45.1, Circumference: 94.0 },
    { Breadth: 44.9, Circumference: 90.4 },
    { Breadth: 44.9, Circumference: 89.4 },
    { Breadth: 44.7, Circumference: 90.4 },
    { Breadth: 44.7, Circumference: 90.45 },
    { Breadth: 41.3, Circumference: 78.0 },
    { Breadth: 42.9, Circumference: 78.9 },
    { Breadth: 42.4, Circumference: 80.4 },
    { Breadth: 42.3, Circumference: 81.7 },
    { Breadth: 42.1, Circumference: 83.9 },
    { Breadth: 41.9, Circumference: 82.9 },
    { Breadth: 41.6, Circumference: 84.6 },
    { Breadth: 41.6, Circumference: 84.60 },
    { Breadth: 41.5, Circumference: 85.1 },
    { Breadth: 41.5, Circumference: 84.3 },
    { Breadth: 41.5, Circumference: 84.34 },
    { Breadth: 41.9, Circumference: 87.9 },
    { Breadth: 42.6, Circumference: 84.0 },
    { Breadth: 42.6, Circumference: 84.0 },
    { Breadth: 42.9, Circumference: 84.9 },
    { Breadth: 42.9, Circumference: 84.9 },
    { Breadth: 43.4, Circumference: 85.8 },
    { Breadth: 43.1, Circumference: 83.5 },
    { Breadth: 42.9, Circumference: 82.2 },
    { Breadth: 43.2, Circumference: 81.7 },
    { Breadth: 43.5, Circumference: 82.8 },
    { Breadth: 43.7, Circumference: 82.7 },
    { Breadth: 43.5, Circumference: 81.3 },
    { Breadth: 43.7, Circumference: 80.9 },
    { Breadth: 43.7, Circumference: 80.94 },
    { Breadth: 43.5, Circumference: 79.4 },
    { Breadth: 43.5, Circumference: 79.40 },
    { Breadth: 43.7, Circumference: 89.0 },
    { Breadth: 43.5, Circumference: 88.4 },
    { Breadth: 43.5, Circumference: 88.42 },
    { Breadth: 43.4, Circumference: 89.45 },
    { Breadth: 43.0, Circumference: 91.5 },
    { Breadth: 42.6, Circumference: 87.9 },
    { Breadth: 42.9, Circumference: 88.4 },
    { Breadth: 42.9, Circumference: 86.8 },
    { Breadth: 42.95, Circumference: 86.89 },
    { Breadth: 43.1, Circumference: 88.5 },
    { Breadth: 44.2, Circumference: 84.7 },
    { Breadth: 44.2, Circumference: 84.7 },
    { Breadth: 44.1, Circumference: 88.6 },
    { Breadth: 44.1, Circumference: 88.66 },
    { Breadth: 43.9, Circumference: 87.6 },
    { Breadth: 44.0, Circumference: 86.6 },
    { Breadth: 44.3, Circumference: 86.5 },
    { Breadth: 44.3, Circumference: 86.5 },
    { Breadth: 44.5, Circumference: 86.9 },
    { Breadth: 44.57, Circumference: 85.5 },
    { Breadth: 44.8, Circumference: 85.8 },
    { Breadth: 45.0, Circumference: 84.6 },
    { Breadth: 45.0, Circumference: 84.64 },
    { Breadth: 44.9, Circumference: 82.7 },
    { Breadth: 44.8, Circumference: 83.7 },
    { Breadth: 44.8, Circumference: 83.75 },
    { Breadth: 44.6, Circumference: 83.3 },
    { Breadth: 44.65, Circumference: 83.37 },
    { Breadth: 44.65, Circumference: 84.5 },
    { Breadth: 44.65, Circumference: 84.53 },
    { Breadth: 44.2, Circumference: 81.8 },
    { Breadth: 44.9, Circumference: 80.2 },
    { Breadth: 45.1, Circumference: 85.5 },
    { Breadth: 44.7, Circumference: 87.1 },
    { Breadth: 44.7, Circumference: 87.10 },
    { Breadth: 44.70, Circumference: 87.10 },
    { Breadth: 44.9, Circumference: 86.8 },
    { Breadth: 45.1, Circumference: 87.2 },
    { Breadth: 45.0, Circumference: 88.6 },
    { Breadth: 45.0, Circumference: 89.4 },
    { Breadth: 45.0, Circumference: 89.41 },
    { Breadth: 44.7, Circumference: 88.5 },
    { Breadth: 44.4, Circumference: 88.3 },
    { Breadth: 44.4, Circumference: 88.3 },
    { Breadth: 44.5, Circumference: 89.4 },
    { Breadth: 44.4, Circumference: 90.0 },
    { Breadth: 43.9, Circumference: 89.3 },
    { Breadth: 44.20, Circumference: 90.2 },
    { Breadth: 44.0, Circumference: 91.2 },
    { Breadth: 44.0, Circumference: 91.24 },
    { Breadth: 44.1, Circumference: 88.5 },
    { Breadth: 44.1, Circumference: 88.53 },
    { Breadth: 44.16, Circumference: 88.5 },
    { Breadth: 44.2, Circumference: 91.7 },
    { Breadth: 44.2, Circumference: 91.75 },
    { Breadth: 43.9, Circumference: 92.7 },
    { Breadth: 43.9, Circumference: 92.79 },
    { Breadth: 44.2, Circumference: 94.8 },
    { Breadth: 44.0, Circumference: 93.8 },
    { Breadth: 44.0, Circumference: 93.81 },
    { Breadth: 44.4, Circumference: 95.6 },
    { Breadth: 44.8, Circumference: 97.4 },
    { Breadth: 44.8, Circumference: 93.6 },
    { Breadth: 44.81, Circumference: 93.67 },
    { Breadth: 44.6, Circumference: 92.5 },
    { Breadth: 44.7, Circumference: 94.57 },
    { Breadth: 45.2, Circumference: 92.2 },
    { Breadth: 45.2, Circumference: 92.24 },
    { Breadth: 45.1, Circumference: 94.0 },
    { Breadth: 45.1, Circumference: 94.0 },
    { Breadth: 44.9, Circumference: 90.4 },
    { Breadth: 44.9, Circumference: 89.4 },
    { Breadth: 44.7, Circumference: 90.4 },
    { Breadth: 44.7, Circumference: 90.45 }
]
export const Cluster2Value = [
    { Breadth: 45.6, Circumference: 91.6 },
    { Breadth: 46.0, Circumference: 92.6 },
    { Breadth: 46.4, Circumference: 94.7 },
    { Breadth: 46.9, Circumference: 97.3 },
    { Breadth: 46.9, Circumference: 97.3 },
    { Breadth: 46.8, Circumference: 98.7 },
    { Breadth: 46.84, Circumference: 98.72 },
    { Breadth: 45.4, Circumference: 95.9 },
    { Breadth: 45.4, Circumference: 94.8 },
    { Breadth: 45.2, Circumference: 97.2 },
    { Breadth: 45.2, Circumference: 95.9 },
    { Breadth: 45.3, Circumference: 97.4 },
    { Breadth: 46.2, Circumference: 96.6 },
    { Breadth: 46.2, Circumference: 98.3 },
    { Breadth: 46.3, Circumference: 96.9 },
    { Breadth: 46.3, Circumference: 96.9 },
    { Breadth: 46.0, Circumference: 97.0 },
    { Breadth: 46.0, Circumference: 97.7 },
    { Breadth: 45.7, Circumference: 97.5 },
    { Breadth: 45.7, Circumference: 98.8 },
    { Breadth: 45.79, Circumference: 98.88 },
    { Breadth: 45.79, Circumference: 98.88 },
    { Breadth: 45.6, Circumference: 98.7 },
    { Breadth: 45.63, Circumference: 98.75 },
    { Breadth: 45.5, Circumference: 99.9 },
    { Breadth: 45.6, Circumference: 101.4 },
    { Breadth: 45.7, Circumference: 102.6 },
    { Breadth: 45.7, Circumference: 102.62 },
    { Breadth: 45.3, Circumference: 101.3 },
    { Breadth: 45.3, Circumference: 103.0 },
    { Breadth: 45.1, Circumference: 100.7 },
    { Breadth: 45.1, Circumference: 100.70 },
    { Breadth: 45.5, Circumference: 102.7 },
    { Breadth: 45.5, Circumference: 103.9 },
    { Breadth: 45.4, Circumference: 105.3 },
    { Breadth: 45.2, Circumference: 108.1 },
    { Breadth: 45.6, Circumference: 108.2 },
    { Breadth: 45.5, Circumference: 107.3 },
    { Breadth: 46.3, Circumference: 107.6 },
    { Breadth: 45.9, Circumference: 106.0 },
    { Breadth: 45.8, Circumference: 104.9 },
    { Breadth: 45.9, Circumference: 104.1 },
    { Breadth: 46.0, Circumference: 103.7 },
    { Breadth: 46.07, Circumference: 105.3 },
    { Breadth: 46.0, Circumference: 105.31 },
    { Breadth: 46.3, Circumference: 105.4 },
    { Breadth: 46.3, Circumference: 105.43 },
    { Breadth: 46.5, Circumference: 105.1 },
    { Breadth: 46.58, Circumference: 105.17 },
    { Breadth: 46.6, Circumference: 104.5 },
    { Breadth: 46.7, Circumference: 104.2 },
    { Breadth: 46.5, Circumference: 102.9 },
    { Breadth: 46.4, Circumference: 102.7 },
    { Breadth: 46.0, Circumference: 102.6 },
    { Breadth: 46.2, Circumference: 104.1 },
    { Breadth: 46.2, Circumference: 104.15 },
    { Breadth: 46.2, Circumference: 104.15 },
    { Breadth: 46.3, Circumference: 101.3 },
    { Breadth: 46.6, Circumference: 100.4 },
    { Breadth: 46.4, Circumference: 99.6 },
    { Breadth: 46.4, Circumference: 100.2 },
    { Breadth: 46.1, Circumference: 100.29 },
    { Breadth: 45.9, Circumference: 99.5 },
    { Breadth: 46.94, Circumference: 102.0 },
    { Breadth: 46.9, Circumference: 102.07 },
    { Breadth: 47.1, Circumference: 99.8 },
    { Breadth: 46.8, Circumference: 101.1 },
    { Breadth: 47.0, Circumference: 101.2 },
    { Breadth: 47.7, Circumference: 96.7 },
    { Breadth: 47.5, Circumference: 98.9 },
    { Breadth: 47.5, Circumference: 100.3 },
    { Breadth: 47.5, Circumference: 100.38 },
    { Breadth: 47.5, Circumference: 101.5 },
    { Breadth: 47.2, Circumference: 102.9 },
    { Breadth: 46.8, Circumference: 103.7 },
    { Breadth: 47.1, Circumference: 102.4 },
    { Breadth: 46.9, Circumference: 104.2 },
    { Breadth: 47.0, Circumference: 105.2 },
    { Breadth: 46.7, Circumference: 106.4 },
    { Breadth: 47.1, Circumference: 106.0 },
    { Breadth: 46.9, Circumference: 106.0 },
    { Breadth: 47.0, Circumference: 106.4 },
    { Breadth: 47.2, Circumference: 106.5 },
    { Breadth: 47.2, Circumference: 108.2 },
    { Breadth: 47.2, Circumference: 109.1 },
    { Breadth: 47.0, Circumference: 109.9 },
    { Breadth: 46.9, Circumference: 108.3 },
    { Breadth: 46.5, Circumference: 108.9 },
    { Breadth: 47.1, Circumference: 113.9 },
    { Breadth: 46.3, Circumference: 113.5 },
    { Breadth: 46.3, Circumference: 110.8 },
    { Breadth: 46.32, Circumference: 110.8 },
    { Breadth: 46.4, Circumference: 111.7 },
    { Breadth: 46.8, Circumference: 112.2 },
    { Breadth: 46.9, Circumference: 112.2 },
    { Breadth: 47.1, Circumference: 111.7 },
    { Breadth: 47.3, Circumference: 110.8 },
    { Breadth: 47.4, Circumference: 106.8 }
]
export const Cluster3Value = [
    { Breadth: 47.6, Circumference: 96.5 },
    { Breadth: 47.6, Circumference: 98.3 },
    { Breadth: 47.5, Circumference: 100.2 },
    { Breadth: 47.5, Circumference: 103.0 },
    { Breadth: 47.6, Circumference: 104.3 },
    { Breadth: 47.8, Circumference: 103.7 },
    { Breadth: 48.3, Circumference: 102.9 },
    { Breadth: 48.2, Circumference: 103.7 },
    { Breadth: 48.3, Circumference: 103.8 },
    { Breadth: 48.6, Circumference: 103.7 },
    { Breadth: 48.7, Circumference: 104.4 },
    { Breadth: 48.8, Circumference: 103.7 },
    { Breadth: 48.3, Circumference: 105.5 },
    { Breadth: 48.3, Circumference: 105.52 },
    { Breadth: 48.4, Circumference: 106.2 },
    { Breadth: 48.46, Circumference: 104.7 },
    { Breadth: 48.7, Circumference: 104.9 },
    { Breadth: 48.7, Circumference: 104.99 },
    { Breadth: 48.7, Circumference: 104.9 },
    { Breadth: 48.8, Circumference: 106.66 },
    { Breadth: 49.3, Circumference: 106.2 },
    { Breadth: 49.0, Circumference: 106.0 },
    { Breadth: 49.2, Circumference: 104.3 },
    { Breadth: 49.7, Circumference: 109.8 },
    { Breadth: 49.6, Circumference: 108.0 },
    { Breadth: 49.5, Circumference: 108.0 },
    { Breadth: 49.3, Circumference: 106.7 },
    { Breadth: 49.1, Circumference: 106.78 },
    { Breadth: 49.0, Circumference: 108.3 },
    { Breadth: 49.1, Circumference: 109.2 },
    { Breadth: 49.3, Circumference: 108.0 },
    { Breadth: 48.9, Circumference: 107.3 },
    { Breadth: 47.7, Circumference: 106.9 },
    { Breadth: 48.1, Circumference: 106.6 },
    { Breadth: 47.9, Circumference: 105.9 },
    { Breadth: 47.9, Circumference: 107.5 },
    { Breadth: 47.8, Circumference: 107.0 },
    { Breadth: 47.8, Circumference: 107.0 },
    { Breadth: 48.3, Circumference: 107.06 },
    { Breadth: 48.1, Circumference: 108.1 },
    { Breadth: 48.4, Circumference: 107.7 },
    { Breadth: 48.2, Circumference: 107.71 },
    { Breadth: 48.3, Circumference: 108.8 },
    { Breadth: 48.31, Circumference: 109.8 },
    { Breadth: 48.0, Circumference: 108.8 },
    { Breadth: 47.9, Circumference: 109.3 },
    { Breadth: 47.8, Circumference: 109.9 },
    { Breadth: 47.8, Circumference: 110.9 },
    { Breadth: 47.82, Circumference: 112.4 },
    { Breadth: 48.1, Circumference: 112.6 },
    { Breadth: 47.9, Circumference: 111.3 },
    { Breadth: 47.9, Circumference: 111.32 },
    { Breadth: 48.6, Circumference: 112.9 },
    { Breadth: 48.0, Circumference: 113.2 },
    { Breadth: 47.8, Circumference: 108.8 },
    { Breadth: 49.0, Circumference: 115.0 },
    { Breadth: 48.9, Circumference: 115.0 },
    { Breadth: 47.6, Circumference: 108.2 },
    { Breadth: 47.6, Circumference: 110.0 },
    { Breadth: 47.7, Circumference: 108.6 },
    { Breadth: 47.9, Circumference: 117.5 },
    { Breadth: 48.3, Circumference: 118.3 },
    { Breadth: 48.6, Circumference: 118.9 },
    { Breadth: 48.7, Circumference: 122.3 },
    { Breadth: 49.4, Circumference: 120.8 },
    { Breadth: 49.3, Circumference: 117.7 },
    { Breadth: 48.6, Circumference: 115.9 },
    { Breadth: 48.7, Circumference: 116.4 },
    { Breadth: 48.3, Circumference: 115.5 },
    { Breadth: 49.2, Circumference: 115.2 },
    { Breadth: 49.5, Circumference: 115.27 },
    { Breadth: 48.6, Circumference: 113.2 },
    { Breadth: 48.5, Circumference: 112.4 },
    { Breadth: 49.0, Circumference: 113.2 },
    { Breadth: 48.9, Circumference: 112.5 },
    { Breadth: 48.8, Circumference: 110.9 },
    { Breadth: 48.6, Circumference: 109.8 },
    { Breadth: 48.6, Circumference: 108.0 },
    { Breadth: 48.5, Circumference: 110.4 },
    { Breadth: 48.5, Circumference: 108.8 },
    { Breadth: 48.8, Circumference: 110.6 },
    { Breadth: 48.8, Circumference: 110.65 },
    { Breadth: 49.0, Circumference: 109.8 },
    { Breadth: 49.2, Circumference: 111.6 },
    { Breadth: 48.8, Circumference: 111.9 },
    { Breadth: 48.9, Circumference: 111.6 },
    { Breadth: 49.3, Circumference: 111.4 },
    { Breadth: 49.3, Circumference: 111.42 },
    { Breadth: 49.3, Circumference: 111.6 },
    { Breadth: 49.4, Circumference: 112.1 },
    { Breadth: 49.5, Circumference: 112.9 },
    { Breadth: 49.7, Circumference: 113.2 },
    { Breadth: 49.9, Circumference: 113.3 },
    { Breadth: 49.6, Circumference: 113.7 },
    { Breadth: 48.9, Circumference: 111.3 },
    { Breadth: 49.0, Circumference: 112.0 },
    { Breadth: 48.8, Circumference: 109.3 }
]
export const Cluster4Value = [
    { Breadth: 50.3, Circumference: 107.0 },
    { Breadth: 50.1, Circumference: 107.5 },
    { Breadth: 50.0, Circumference: 110.2 },
    { Breadth: 49.8, Circumference: 110.7 },
    { Breadth: 50.0, Circumference: 111.2 },
    { Breadth: 50.0, Circumference: 112.0 },
    { Breadth: 50.1, Circumference: 112.17 },
    { Breadth: 50.0, Circumference: 113.2 },
    { Breadth: 50.6, Circumference: 113.4 },
    { Breadth: 50.3, Circumference: 114.7 },
    { Breadth: 50.3, Circumference: 115.3 },
    { Breadth: 50.2, Circumference: 116.5 },
    { Breadth: 49.8, Circumference: 116.8 },
    { Breadth: 49.9, Circumference: 117.9 },
    { Breadth: 49.94, Circumference: 121.9 },
    { Breadth: 50.3, Circumference: 123.2 },
    { Breadth: 50.6, Circumference: 121.4 },
    { Breadth: 50.9, Circumference: 121.0 },
    { Breadth: 50.7, Circumference: 118.4 },
    { Breadth: 50.70, Circumference: 118.2 },
    { Breadth: 50.8, Circumference: 117.1 },
    { Breadth: 50.8, Circumference: 115.2 },
    { Breadth: 50.9, Circumference: 112.7 },
    { Breadth: 50.6, Circumference: 112.4 },
    { Breadth: 50.5, Circumference: 111.5 },
    { Breadth: 50.7, Circumference: 110.6 },
    { Breadth: 50.7, Circumference: 111.3 },
    { Breadth: 50.8, Circumference: 110.9 },
    { Breadth: 51.0, Circumference: 111.8 },
    { Breadth: 50.7, Circumference: 108.8 },
    { Breadth: 50.6, Circumference: 108.2 },
    { Breadth: 50.65, Circumference: 108.2 },
    { Breadth: 51.2, Circumference: 108.6 },
    { Breadth: 51.8, Circumference: 112.0 },
    { Breadth: 52.3, Circumference: 113.6 },
    { Breadth: 51.1, Circumference: 115.4 },
    { Breadth: 51.8, Circumference: 115.7 },
    { Breadth: 51.7, Circumference: 117.2 },
    { Breadth: 52.0, Circumference: 119.5 },
    { Breadth: 52.0, Circumference: 120.6 },
    { Breadth: 51.9, Circumference: 122.9 },
    { Breadth: 51.9, Circumference: 124.8 },
    { Breadth: 51.17, Circumference: 124.7 },
    { Breadth: 52.3, Circumference: 128.0 },
    { Breadth: 52.3, Circumference: 128.0 },
    { Breadth: 52.6, Circumference: 124.9 },
    { Breadth: 52.7, Circumference: 124.2 },
    { Breadth: 52.5, Circumference: 120.2 },
    { Breadth: 52.8, Circumference: 119.7 }
]
export const Cluster5Value = [
    { Breadth: 53.1, Circumference: 121.3 },
    { Breadth: 53.0, Circumference: 122.4 },
    { Breadth: 54.6, Circumference: 133.4 },
    { Breadth: 53.3, Circumference: 122.6 },
    { Breadth: 53.6, Circumference: 125.4 },
    { Breadth: 53.9, Circumference: 128.5 },
    { Breadth: 53.3, Circumference: 125.7 },
    { Breadth: 53.3, Circumference: 125.78 },
    { Breadth: 54.0, Circumference: 127.0 },
    { Breadth: 54.0, Circumference: 127.05 },
    { Breadth: 53.1, Circumference: 127.3 },
    { Breadth: 53.6, Circumference: 121.36 },
    { Breadth: 52.6, Circumference: 123.4 },
    { Breadth: 54.0, Circumference: 123.2 },
    { Breadth: 53.8, Circumference: 124.8 },
    { Breadth: 53.3, Circumference: 123.3 },
    { Breadth: 53.3, Circumference: 124.3 },
    { Breadth: 53.8, Circumference: 123.6 },
    { Breadth: 53.8, Circumference: 124.61 },
    { Breadth: 53.5, Circumference: 123.5 }
]